import { RequestedFeedback } from "../models/auth-status";
import { Contact } from "../models/contact";
import { Skill } from "../models/skill";

export class ContactHelper {
    static DAYS_BEFORE_AVAILABLE = 30;

    static canRequestFeedback(requestFeedback: RequestedFeedback[], contact: Contact, skill: Skill): boolean {
        const feedback = requestFeedback.find(r => r.skill === skill.id);
        if (!feedback) {
            return true;
        }
        const recipients = feedback.recipients.filter(r => r.email === contact.email);
        if (recipients.length !== 0) {
            // Find the latest date
            const lastContact = Math.max(...recipients.map(c => new Date(c.date).getTime()));
            return lastContact < Date.now() - ContactHelper.DAYS_BEFORE_AVAILABLE * 24 * 60 * 60 * 1000;
        }
        return true;
    }
}
